module.exports = __webpack_public_path__ + "sheep.jpg?45a5a0a14ff39af2eb5ab870f1efc763";